import gql from 'graphql-tag';

export const GETCARGO = gql`
    query ($id:ID){
        cargo(id:$id){
            _id
            idDB
            nombre
            negocio
            grupo{
                _id
                nombre
            }
            A{
                porcentajes{
                    minimo
                    maximo
                    valor
                }
            }
            AA{
                porcentajes{
                    minimo
                    maximo
                    valor
                }
            }
            AAA{
                porcentajes{
                    minimo
                    maximo
                    valor
                }
            }
        }
    }
`;


export const GETCARGOS = gql`
    query {
        cargos{
            _id
            idDB
            nombre
            negocio
            grupo{
                _id
                nombre
            }
        }
    }
`;

export const EDITCARGO = gql`
    mutation($cargo:String){
        editCargo(cargo:$cargo)
    }
`;

export const NEWCARGO = gql`
    mutation($cargo:String){
        crearCargo(cargo:$cargo)
    }
`;

export const DUPLICARCARGO = gql`
    mutation ($id: String){
        duplicarCargo(id:$id)
    }
`;

export const GETGRUPOSCARGOS = gql`
    query{
        gruposCargos{
            _id
            nombre
            tiendas
        }
    }
`;

export const GETGRUPOCARGO = gql`
    query($id:ID){
        grupoCargo(id:$id){
            _id
            nombre
            tiendas
        }
    }
`;

export const EDITGRUPOCARGO = gql`
    mutation($grupo:String){
        editGrupoCargo(data:$grupo)
    }
`;

export const NEWGRUPOCARGO = gql`
    mutation($grupo:String){
        crearGrupoCargo(data:$grupo)
    }
`;
